import type { ToastKinds } from './toaster.types'
import { ToastKind } from './toaster.types'

export const PERSISTENT_TOAST_KINDS = new Set<ToastKinds>([
  ToastKind.ERROR,
  ToastKind.WARN,
])

export const TOAST_REMOVE_TIMEOUT_DURATION_IN_MILLISECONDS = 2000
